import {
  createTheme,
  CSSVariablesResolver,
  MantineColorsTuple,
  Portal,
} from '@mantine/core'

// Generated with Adobe Leonardo (@adobe/leonardo-contrast-colors) to hit set
// contrast ratios against white: colorKeys ['#ffc130', '#e49f00', '#6b4300'],
// colorspace OKLCH, smooth, ratios [1.05, 1.12, 1.25, 1.45, 1.63, 1.95, 2.27,
// 3.2, 4.8, 7.5]. Shade 4 is the brand yellow, 6 the fill colour, 7 is enough
// for icons and borders (3:1) and 8 and 9 for text (4.5:1 and 7:1).
export const brandColors: MantineColorsTuple = [
  `#fff9ed`,
  `#fff1d4`,
  `#ffe3a8`,
  `#ffd06a`,
  `#ffc02d`,
  `#f3ac00`,
  `#e49f00`,
  `#c28300`,
  `#9d6700`,
  `#774b00`,
]

export const theme = createTheme({
  fontFamily: `Nunito Sans, sans-serif`,
  breakpoints: {
    xs: `30em`,
    sm: `48em`,
    md: `64em`,
    lg: `74em`,
    xl: `90em`,
  },
  headings: {
    fontFamily: `Nunito Sans, sans-serif`,
  },
  colors: {
    brand: brandColors,
  },
  primaryColor: `brand`,
  primaryShade: 6,
  autoContrast: true,
  components: {
    Button: {
      styles: () => ({
        root: {
          borderRadius: 1000,
        },
      }),
    },
    Table: {
      styles: () => ({
        thead: {
          backgroundColor: 'var(--mantine-primary-color-light)',
        },
      }),
    },
    Portal: Portal.extend({
      defaultProps: {
        reuseTargetNode: false,
      },
    }),
  },
})

// In light mode Mantine uses the fill shade for text, outlines and links too.
// A yellow fill is unreadable as text on white, so point those at shade 8.
// Dark mode already uses the light end of the palette for text.
export const cssVariablesResolver: CSSVariablesResolver = () => ({
  variables: {},
  light: {
    '--mantine-color-brand-text': `var(--mantine-color-brand-8)`,
    '--mantine-color-brand-outline': `var(--mantine-color-brand-8)`,
    '--mantine-color-anchor': `var(--mantine-color-brand-8)`,
  },
  dark: {},
})
